export default "__VITE_ASSET__uAPb1SeR__"